export enum ItemInfoType {
  TEXT = 'text',
  DATA = 'data',
  TAG = 'tag',
  LINK = 'link'
}

